import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { SectionCard, StatusBadge, GradeBadge, EmptyState } from "@/components/common/Primitives";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";

export default function ReviewPage() {
  const nav = useNavigate();
  const [audits, setAudits] = useState([]);
  useEffect(() => { api.get("/audits?status=submitted").then(({ data }) => setAudits(data)); }, []);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-semibold">Assessment</div>
        <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-slate-900">Manager Review Queue</h1>
        <p className="text-sm text-slate-600 mt-1">Audits pending manager decision.</p>
      </div>
      <SectionCard title="Pending Reviews" subtitle={`${audits.length} audit(s) awaiting your decision`}>
        {audits.length === 0 ? <EmptyState title="Inbox zero" message="No audits are currently awaiting your review." /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-slate-100 text-slate-600 text-xs uppercase tracking-wider">
                  <th className="text-left px-3 py-2">Audit #</th>
                  <th className="text-left px-3 py-2">Supplier</th>
                  <th className="text-left px-3 py-2">Submitted</th>
                  <th className="text-right px-3 py-2">Score</th>
                  <th className="text-center px-3 py-2">Grade</th>
                  <th className="text-left px-3 py-2">Status</th>
                  <th className="text-right px-3 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {audits.map((a) => (
                  <tr key={a.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                    <td className="px-3 py-2 font-mono text-xs">{a.audit_number}</td>
                    <td className="px-3 py-2 font-semibold text-slate-900">{a.supplier?.name || "—"}</td>
                    <td className="px-3 py-2 font-mono text-xs">{a.submitted_at ? new Date(a.submitted_at).toLocaleDateString() : "—"}</td>
                    <td className="px-3 py-2 text-right font-mono font-semibold">{a.percentage}%</td>
                    <td className="px-3 py-2 text-center"><GradeBadge grade={a.grade} /></td>
                    <td className="px-3 py-2"><StatusBadge status={a.status} /></td>
                    <td className="px-3 py-2 text-right">
                      <Button size="sm" onClick={() => nav(`/audits/${a.id}`)} className="h-8 bg-sams-primary hover:bg-sams-primaryHover text-white"
                        data-testid={`review-open-${a.id}`}>
                        <Eye size={12} className="mr-1" /> Review
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>
    </div>
  );
}
